import type { AuthUserToken } from '@/features/signin/domains/auth_user_token'
import type { AuthUser } from '../../domains/auth_user'
import type { AuthUserTokenEntity, UserEntity } from '../entity/auth_user_token_entity'

export class AuthUserMapper {
  public static toDomain(payload: AuthUserTokenEntity): AuthUserToken {
    return {
      accessToken: payload.access_token,
      expireIn: payload.expires_in,
      tokenType: payload.token_type,
      user: {
        id: payload.user.id,
        name: payload.user.nombre,
        lastName: payload.user.apellido,
        email: payload.user.correo,
        numberDocument: payload.user.cedula,
        rol: payload.user.cargo,
        phone: payload.user.celular,
        bussine: payload.user.empresa,
        bussine_id: payload.user.empresa_id,
        workshop: payload.user.workshop
          ? {
              id: payload.user.workshop.taller_id,
              name: payload.user.workshop.taller_nombre,
              image: payload.user.workshop.image,
              trainerId: payload.user.workshop.formador_id,
              trainerName: payload.user.workshop.formador_nombre,
              trainerPhoto: payload.user.workshop.formador_foto,
              city: payload.user.workshop.ciudad,
              date: payload.user.workshop.fecha,
              time: payload.user.workshop.hora,
              notifierId: payload.user.workshop.notificador_id,
            }
          : undefined,
        speciality: payload.user.especialidad,
        photo: payload.user.foto,
        photo_bussines: payload.user.foto_empresa,
        calification: payload.user.evaluar,
        gener: payload.user.genero,
        newUser: payload.user.nuevo,
        rememberToken: payload.user.remember_token,
        rolId: payload.user.rol_id,
        typeWorkShopId: payload.user.typeworkshop_id,
        urlDropbox: payload.user.url_dropbox,
        perfil: payload.user.perfil,
        sobre_mi: payload.user.sobre_mi,
        createdAt: payload.user.created_at,
        updatedAt: payload.user.updated_at,
      },
    }
  }

  public static toDomainUser(payload: UserEntity): AuthUser {
    return {
      id: payload.id,
      name: payload.nombre,
      lastName: payload.apellido,
      email: payload.correo,
      numberDocument: payload.cedula,
      rol: payload.cargo,
      phone: payload.celular,
      bussine: payload.empresa,
      bussine_id: payload.empresa_id,
      speciality: payload.especialidad,
      photo: payload.foto,
      photo_bussines: payload.foto_empresa,
      calification: payload.evaluar,
      gener: payload.genero,
      newUser: payload.nuevo,
      rememberToken: payload.remember_token,
      rolId: payload.rol_id,
      typeWorkShopId: payload.typeworkshop_id,
      urlDropbox: payload.url_dropbox,
      perfil: payload.perfil,
      sobre_mi: payload.sobre_mi,
      createdAt: payload.created_at,
      updatedAt: payload.updated_at,
    }
  }
}
